import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthSignalService } from '../services/auth-signal.service';

export const reportsGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthSignalService);

  console.log('ReportsGuard running');
  
  // Verificar si hay un usuario autenticado
  const isAuthenticated = authService.isAuthenticated();
  
  if (!isAuthenticated) {
    console.log('No authenticated user, redirecting to login');
    router.navigate(['/auth/login']);
    return false;
  }
  
  // Obtener usuario actual
  const currentUser = authService.account();
  
  // Verificar si el usuario tiene permiso para reportes
  const hasReportsPermission = currentUser && (
    (currentUser.role !== undefined && ['ADMIN', 'SECURITY_OFFICER'].includes(currentUser.role)) || 
    (currentUser.isAdmin !== undefined && currentUser.isAdmin === true) ||
    (currentUser.permissions !== undefined && (
      currentUser.permissions.includes('ADMIN') || 
      currentUser.permissions.includes('report.view')
    ))
  );
  
  if (hasReportsPermission) {
    console.log('User has reports permission, proceeding');
    return true;
  } else {
    console.log('User does not have reports permission, redirecting to dashboard');
    
    // Navegar al dashboard con pequeño delay para asegurar que se complete
    setTimeout(() => {
      router.navigate(['/dashboard']);
    }, 50);
    
    return false;
  }
};